export const copyToClipboard = async(text) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";
            
        document.body.prepend(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            message.info('Ссылка скопирована в буфер обмена')
        } catch (error) {
            console.error(error);
        } finally {
            textArea.remove();
        }
    }